import {
  BooleanField,
  Datagrid,
  List,
  NumberField,
  SelectField,
  TextField,
} from 'react-admin';
import { QuickbooksPriceField } from '../components/QuickbooksPriceField';
import { itemsTypes } from './items-types';

export const ItemsList = () => (
  <List hasCreate={false}>
    <Datagrid bulkActionButtons={false}>
      <NumberField source="id" />
      <SelectField source="Type" choices={itemsTypes} />
      <TextField source="Name" />
      <TextField source="Description" />
      <QuickbooksPriceField source="UnitPrice" />
      <BooleanField source="Active" />
    </Datagrid>
  </List>
);
